import axiosClient from '../api/AxiosConfig';

export const AdsService = {
    GetAds: async () => {
        return (await axiosClient.get('/ctkm/private')).data;
    },
    DisableAds: async (id) => {
        return (await axiosClient.patch(`/ctkm/disable/${id}`)).data;
    },
    EnableAds: async (id) => {
        return (await axiosClient.patch(`/ctkm/enable/${id}`)).data;
    },
    GetAdsId: async (id) => {
        return (await axiosClient.get(`/ctkm/private/${id}`)).data;
    },
    EditAds: async (id, data) => {
        return (await axiosClient.put(`/ctkm/edit/${id}`, data)).data;
    },
    CreateAds: async (data) => {
        return (await axiosClient.post(`/ctkm`, data)).data;
    },
    DeleteAds: async (id) => {
        return (await axiosClient.delete(`/ctkm/delete/${id}`)).data;
      },
}